import React, { useState, useEffect, useRef, useContext } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import * as Yup from 'yup'
import { Formik } from 'formik'
import { Box, Container, Typography, TextField, Button } from '@material-ui/core'

// API
import { getPublicAPI } from '../api'

// components
import Loader from '../components/utils/Loader'

import { ToastContext } from '../contexts/Toast'

const OrderDownload = () => {
   let mounted = useRef(true)

   const navigate = useNavigate()
   const { order } = useParams()
   const { setToasts } = useContext(ToastContext)

   const [loading, setLoading] = useState(true)
   const [email, setEmail] = useState('')
   // const [message, setMessage] = useState({ type: '', info: '' })

   useEffect(() => {
      setTimeout(() => {
         if (!order) navigate('/404')
         mounted.current && setLoading(false)
      }, 1000)

      const prepareOrderDownload = async () => {
         let getOrder = await getPublicAPI('/get-order', {
            orderUrl: order
         })

         if (mounted.current) {
            if (getOrder?.success) {
               // let ip_address = localStorage.ip_address
               // localStorage.clear()
               // localStorage.setItem('ip_address', ip_address)
               localStorage.setItem('order_num', getOrder.data?.order || '')

               setEmail(getOrder.data?.email)
               if (localStorage.auth_token && localStorage.user_email === getOrder.data.email)
                  navigate('/app/order-detail/' + localStorage.order_num, { replace: true })
               if (!localStorage.auth_token) setEmail('')
               if (localStorage.auth_token && localStorage.user_type !== 'customer')
                  navigate('/app/order-detail/' + localStorage.order_num, { replace: true })
               if (localStorage.auth_token && localStorage.user_email !== getOrder.data.email)
                  setEmail(localStorage.user_email)
               // let downloadLink = document.createElement('a')
               // downloadLink.href = getOrder.data
               // downloadLink.download = getOrder.data
               // downloadLink.click()

               // setMessage({ type: 'success', info: 'Order has been downloaded' })
               // setToasts({
               //    type: 'success',
               //    messages: [{ msg: 'Order has been downloaded' }]
               // })
            } else {
               // setMessage({ type: 'error', info: getOrder?.errors[0].msg })
               localStorage.setItem('order_num', '')
               setToasts({
                  type: 'error',
                  messages: getOrder?.errors
               })
            }
         }
      }

      prepareOrderDownload()

      return () => (mounted.current = false)
   }, [order, navigate, setToasts])

   const onSubmit = async values => {
      try {
         let login = await getPublicAPI('/login', values)

         if (login?.success) {
            const { id, name, token, email, type, phone, address, company, picture, status } =
               login.data
            localStorage.setItem('user_id', id)
            localStorage.setItem('user_name', name)
            localStorage.setItem('auth_token', token)
            localStorage.setItem('user_email', email)
            localStorage.setItem('user_phone', phone)
            localStorage.setItem('user_address', address)
            localStorage.setItem('user_company', company)
            localStorage.setItem('user_type', type)
            localStorage.setItem('user_pic', picture)

            localStorage.setItem('user_status', status)
            if (status === 'Disabled') {
               localStorage.clear()
               navigate('/login', { replace: true })
               setToasts({
                  type: 'error',
                  messages: [{ msg: 'Account Disabled' }]
               })
            } else {
               setToasts({
                  type: 'success',
                  messages: [{ msg: 'Successful login' }]
               })

               let orderNum = localStorage.order_num
               localStorage.removeItem('order_num')

               navigate('/app/order-detail/' + orderNum, { replace: true })
            }
         } else
            setToasts({
               type: 'error',
               messages: login?.errors
            })
      } catch (err) {
         setToasts({
            type: 'error',
            messages: [{ msg: `error in logging in ${err.message}` }]
         })
      }
   }

   // let color = message.type === 'error' ? '#d22f25' : 'green'
   return (
      <>
         <Helmet>
            <title>{loading ? 'Loading...' : `Download order | The HosePod`}</title>
         </Helmet>
         <Box
            sx={{
               backgroundColor: 'background.default',
               minHeight: '100%',
               py: 3
            }}
         >
            <Container maxWidth='sm'>
               {loading ? (
                  <Loader />
               ) : localStorage.order_num === '' ? (
                  <>
                     <Box sx={{ p: 5 }}>
                        <Typography
                           sx={{
                              fontWeight: '600',
                              fontSize: '24px',
                              textAlign: 'center'
                           }}
                        >
                           No orders.
                        </Typography>
                     </Box>
                  </>
               ) : (
                  // <Box sx={{ textAlign: 'center', mt: '30vh' }}>
                  //    <Typography sx={{ fontSize: '30px', color, fontWeight: 500 }}>
                  //       {message.info}
                  //    </Typography>
                  // </Box>
                  <Formik
                     initialValues={{
                        email: email,
                        password: ''
                     }}
                     validationSchema={Yup.object().shape({
                        email: Yup.string()
                           .email('Must be a valid email')
                           .max(255)
                           .required('Email is required'),
                        password: Yup.string().max(255).required('Password is required')
                     })}
                     onSubmit={onSubmit}
                  >
                     {({
                        errors,
                        handleBlur,
                        handleChange,
                        handleSubmit,
                        isSubmitting,
                        touched,
                        values
                     }) => (
                        <form onSubmit={handleSubmit}>
                           <Box sx={{ mb: 3 }}>
                              <Typography color='textPrimary' variant='h2'>
                                 Sign in to view the order
                              </Typography>
                           </Box>
                           <TextField
                              error={Boolean(touched.email && errors.email)}
                              fullWidth
                              helperText={touched.email && errors.email}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              label='Email Address'
                              margin='normal'
                              name='email'
                              type='email'
                              value={values.email}
                              variant='outlined'
                           />
                           <TextField
                              error={Boolean(touched.password && errors.password)}
                              fullWidth
                              helperText={touched.password && errors.password}
                              label='Password'
                              margin='normal'
                              name='password'
                              onBlur={handleBlur}
                              onChange={handleChange}
                              type='password'
                              value={values.password}
                              variant='outlined'
                           />
                           <Box sx={{ py: 2 }}>
                              <Button
                                 color='primary'
                                 disabled={isSubmitting}
                                 fullWidth
                                 size='large'
                                 type='submit'
                                 variant='contained'
                              >
                                 Sign in now
                              </Button>
                           </Box>
                        </form>
                     )}
                  </Formik>
               )}
            </Container>
         </Box>
      </>
   )
}

export default OrderDownload
